<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col lg="8" cols="12" class="mx-auto mb-6">
          <v-stepper
            alt-labels
            elevation="0"
            v-model="e1"
            class="bg-transparent overflow-visible"
          >
            <v-stepper-header class="shadow-0">
              <v-stepper-step step="1" color="#344767">
                <span class="text-secondary font-weight-normal"
                  >1. Start</span
                >
              </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step v-if="false"  step="2" color="#344767">
                <span class="text-secondary font-weight-normal">2. Media</span>
              </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step v-if="false"  step="3" color="#344767">
                <span class="text-secondary font-weight-normal"
                  >3. Socials</span
                >
              </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step step="4" color="#344767">
                <span class="text-secondary font-weight-normal"
                  >2. Preview</span
                >
              </v-stepper-step>
            </v-stepper-header>

            <v-stepper-items
              class="border-radius-xl overflow-hidden shadow-lg mt-8"
            >
              <v-stepper-content
                step="1"
                class="bg-white border-radius-xl px-4 pt-4"
              >
                <v-card>
                  <div>
                    <h5 class="font-weight-bolder text-h5 text-typo mb-0">
                      Cancellation Date
                    </h5>
                    <v-row class="mt-2">
                      <v-col sm="12" cols="12">
                        <label class="text-xs text-typo font-weight-bolder ms-1 mb-2"
                          >Select the date when cancellation should start</label
                        >
                        <v-row justify="center" class="mt-5">
                          <v-date-picker
                             color="green lighten-1"
                             header-color="blue"
                             v-model="picker">
                          </v-date-picker>
                        </v-row>
                      </v-col>
                    </v-row>

                    <v-row v-if="false" class="mt-2">
                      <v-col sm="6" cols="12" class="mb-sm-0 mb-16">
                        <label class="text-xs text-typo font-weight-bolder ms-1"
                          >Description</label
                        >
                        <p class="form-text text-muted text-xs ms-1 d-inline">
                          (optional)
                        </p>
                        <html-editor></html-editor>
                      </v-col>
                      <v-col sm="6" cols="12">
                        <label class="text-xs text-typo font-weight-bolder ms-1"
                          >Category</label
                        >
                        <v-select
                          :items="categories"
                          value="Clothing"
                          color="rgba(0,0,0,.6)"
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            border-radius-md
                            select-style
                            mt-2
                            mb-0
                          "
                          outlined
                          single-line
                          height="38"
                        >
                        </v-select>
                        <label class="text-xs text-typo font-weight-bolder ms-1"
                          >Sizes</label
                        >
                        <v-select
                          :items="sizes"
                          value="Medium"
                          color="rgba(0,0,0,.6)"
                          class="
                            input-style
                            font-size-input
                            text-light-input
                            placeholder-light
                            border-radius-md
                            select-style
                            mt-2
                            mb-0
                          "
                          outlined
                          single-line
                          height="38"
                        >
                        </v-select>
                      </v-col>
                    </v-row>
                  </div>
                  <div class="text-end">
                    <v-btn
                      :ripple="false"
                      :elevation="0"
                      class="
                        font-weight-bold
                        text-xs
                        btn-default
                        bg-gradient-default
                        py-5
                        px-6
                        mt-6
                        mb-2
                        me-2
                      "
                      color="primary"
                      @click="e1 = 4"
                    >
                      Next
                    </v-btn>
                  </div>
                </v-card>
              </v-stepper-content>

              <v-stepper-content
                step="2"
                class="bg-white border-radius-xl px-4 pt-4"
              >
                <v-card>
                  <div>
                    <h5 class="font-weight-bolder text-h5 text-typo mb-0">
                      Media
                    </h5>
                    <v-row class="mt-2">
                      <v-col cols="12">
                        <label class="text-xs text-typo font-weight-bolder ms-1"
                          >Product images</label
                        >
                        <dropzone v-model="fileSingle"></dropzone>
                      </v-col>
                    </v-row>
                  </div>
                  <div class="d-flex">
                    <v-btn
                      :ripple="false"
                      :elevation="0"
                      class="
                        font-weight-bold
                        text-xs text-dark
                        btn-light
                        bg-gradient-light
                        py-5
                        px-6
                        mt-6
                        mb-2
                        ms-2
                      "
                      @click="e1 = 1"
                    >
                      Prev
                    </v-btn>
                    <v-btn
                      :ripple="false"
                      :elevation="0"
                      class="
                        font-weight-bold
                        text-xs
                        btn-default
                        bg-gradient-default
                        py-5
                        px-6
                        mt-6
                        mb-2
                        me-2
                        ms-auto
                      "
                      color="primary"
                      @click="e1 = 3"
                    >
                      Next
                    </v-btn>
                  </div>
                </v-card>
              </v-stepper-content>

              <v-stepper-content
                step="3"
                class="bg-white border-radius-xl px-4 pt-4"
              >
                <v-card>
                  <div>
                    <h5 class="font-weight-bolder text-h5 text-typo mb-0">
                      Socials
                    </h5>
                    <v-row class="mt-2">
                      <v-col cols="12">
                        <label class="text-xs text-typo font-weight-bolder ms-1"
                          >Shopify Handle</label
                        >
                        <v-text-field
                          hide-details
                          outlined
                          color="rgba(0,0,0,.6)"
                          light
                          placeholder="@soft"
                          class="
                            font-size-input
                            placeholder-lighter
                            border border-radius-md
                            mt-2
                          "
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="mt-2">
                      <v-col cols="12">
                        <label class="text-xs text-typo font-weight-bolder ms-1"
                          >Facebook Account</label
                        >
                        <v-text-field
                          hide-details
                          outlined
                          color="rgba(0,0,0,.6)"
                          light
                          placeholder="https://..."
                          class="
                            font-size-input
                            placeholder-lighter
                            border border-radius-md
                            mt-2
                          "
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="mt-2">
                      <v-col cols="12">
                        <label class="text-xs text-typo font-weight-bolder ms-1"
                          >Instagram Account</label
                        >
                        <v-text-field
                          hide-details
                          outlined
                          color="rgba(0,0,0,.6)"
                          light
                          placeholder="https://..."
                          class="
                            font-size-input
                            placeholder-lighter
                            border border-radius-md
                            mt-2
                          "
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </div>
                  <div class="d-flex">
                    <v-btn
                      :ripple="false"
                      :elevation="0"
                      class="
                        font-weight-bold
                        text-xs text-dark
                        btn-light
                        bg-gradient-light
                        py-5
                        px-6
                        mt-6
                        mb-2
                        ms-2
                      "
                      @click="e1 = 2"
                    >
                      Prev
                    </v-btn>
                    <v-btn
                      :ripple="false"
                      :elevation="0"
                      class="
                        font-weight-bold
                        text-xs
                        btn-default
                        bg-gradient-default
                        py-5
                        px-6
                        mt-6
                        mb-2
                        me-2
                        ms-auto
                      "
                      color="primary"
                      @click="e1 = 4"
                    >
                      Next
                    </v-btn>
                  </div>
                </v-card>
              </v-stepper-content>

              <v-stepper-content
                step="4"
                class="bg-white border-radius-xl px-4 pt-4"
              >
                <v-card height=450px">
                  <div>
                    <h5 class="font-weight-bolder text-h5 text-typo mb-0">
                      Preview
                    </h5>
                    <v-row class="mt-2">
                      <v-col cols="12">
                        <div class="px-4 py-4">
                          <p class="mb-6 text-h6"><b>Dear: </b>SIR/MADAM</p>
                          <p class="mb-6 text-h6"><b>RE: <u>APPLICATION TO DEREGISTER AS AN </u></b></p>
                          <p class="mb-6 text-body">
                            Please cancel my registration with effect from <b>31 December 2023</b>.This cancellation is
                            inline with clause 8[9][b] of statutory instrument 45 of 2013, which states that the employer
                            should notify council within thirty days of cessation of operation.
                          </p>
                          <p class="mb-6 text-body">
                            <b>SIGNED:</b> Construction Company &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <b>DATE:</b> 04 June 2023

                          </p>
                          <v-img
                              v-if="false"
                              src="https://images.unsplash.com/photo-1552581234-26160f608093?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2100&q=80"
                              class="border-radius-lg shadow-lg"
                          >
                          </v-img>
                          <v-row v-if="false" class="align-center px-2 mt-6 mb-2">
                            <v-col sm="6">
                              <div class="d-flex">
                                <div class="d-flex align-center">
                                  <v-icon size="16"
                                  >ni ni-like-2 me-1 text-body cursor-pointer</v-icon
                                  >
                                  <span class="text-sm text-body me-4">150</span>
                                </div>
                                <div class="d-flex align-center">
                                  <v-icon size="16"
                                  >ni ni-chat-round me-1 text-body cursor-pointer</v-icon
                                  >
                                  <span class="text-sm text-body me-4">36</span>
                                </div>
                                <div class="d-flex align-center">
                                  <v-icon size="16"
                                  >ni ni-curved-next me-1 text-body cursor-pointer</v-icon
                                  >
                                  <span class="text-sm text-body me-4">12</span>
                                </div>
                              </div>
                            </v-col>
                            <v-col sm="6">
                              <div class="d-flex align-center">
                                <div class="d-flex align-items-center ms-auto">
                                  <v-avatar size="24" class="border border-white ms-n2">
                                    <img src="@/assets/img/team-5.jpg" alt="Avatar" />
                                  </v-avatar>
                                  <v-avatar size="24" class="border border-white ms-n2">
                                    <img src="@/assets/img/team-2.jpg" alt="Avatar" />
                                  </v-avatar>
                                  <v-avatar size="24" class="border border-white ms-n2">
                                    <img src="@/assets/img/team-1.jpg" alt="Avatar" />
                                  </v-avatar>
                                </div>
                                <small class="ps-2 font-weight-bold text-body"
                                >and 30+ more</small
                                >
                              </div>
                            </v-col>
                          </v-row>
                          <div class="mb-1">
                            <hr class="horizontal dark mt-1 mb-5" />
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                  <div class="d-flex">
                    <v-btn
                      :ripple="false"
                      class="
                        font-weight-bold
                        placeholder-lighter
                        text-xs text-dark
                        btn-light
                        bg-gradient-light
                        py-5
                        px-6
                        mt-6
                        mb-0
                      "
                      @click="e1 = 1"
                    >
                      Prev
                    </v-btn>
                    <v-btn
                      :ripple="false"
                      class="
                        font-weight-bold
                        text-xs
                        btn-default
                        bg-gradient-default
                        py-5
                        px-6
                        mt-6
                        mb-0
                        ms-auto
                      "
                      color="primary"
                      @click="e1 = 4"
                    >
                      Send
                    </v-btn>
                  </div>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import HtmlEditor from "./Widgets/HtmlEditor.vue";
import Dropzone from "./Widgets/Dropzone.vue";

export default {
  components: {
    HtmlEditor,
    Dropzone,
  },
  data() {
    return {
      e1: 1,
      categories: [
        "Clothing",
        "Electronics",
        "Furniture",
        "Others",
        "Real Estate",
      ],
      picker: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      sizes: ["Small", "Medium", "Large"],
      fileSingle: [],
      coins: ["USD", "BTC", "CNY", "EUR"],
      tags: ["Black Friday", "Sale", "Out of stock", "In stock"],
    };
  },
};
</script>
